import { TealiumProfiles } from '@legalzoom/tracking';
import { useRef } from 'react';
import { type UIMatch, useLocation, useMatches } from 'react-router';
import { type FeatureFlags } from './constants';
import { useRootLoaderData } from './root';
import { isAuthenticatedLoaderData } from './loaderData';
import type { RouteHandle } from './types';
import { isTaxPage } from './utilities/tax';

export const useWorkspace = () => {
  const loaderData = useRootLoaderData();
  if (isAuthenticatedLoaderData(loaderData)) {
    return loaderData.workspace;
  }
  return {};
};

export const useFeatureFlags = (...flags: FeatureFlags[]) => {
  const featureFlags = (useRootLoaderData().featureFlags ?? {}) as Record<
    string,
    unknown
  >;
  return flags.map((flag) => (featureFlags ? featureFlags[flag] : false));
};

export const useCurrentTealiumProfile = () => {
  const location = useLocation();
  return useRef(
    isTaxPage(location) ? TealiumProfiles.TAX : TealiumProfiles.MAIN,
  ).current;
};

export const useHandle = <T>(property: string, defaultValue: T): T => {
  const matches = useMatches() as UIMatch<unknown, RouteHandle>[];
  return (matches
    .filter((match) => !!match?.handle?.[property as keyof RouteHandle])
    .pop()?.handle?.[property as keyof RouteHandle] ?? defaultValue) as T;
};
